import { ReactElement } from "react";
import { FormConfig } from "@evergiving/common/dist/es2015/form";

export function LogoContainer({
  formConfig,
}: {
  formConfig: FormConfig;
}): ReactElement {
  return (
    <div className="logos">
      <div className="logo1" />
      <div className="logo2" />
      <h1 className="screenReaderOnly">{formConfig.charityNameText}</h1>
    </div>
  );
}
